// Payment receipt modal (§10.2): status chip, processing/failed notes, the
// ordered rows, Copy details and Repeat.
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import type { Payment } from '@/types/phase2.types';
import Button from '@/components/ui/Button/Button';
import PaymentStatusChip from './PaymentStatusChip';
import { receiptCopyText, receiptRows } from './payUtils';

interface PaymentReceiptProps {
  payment: Payment | null;
  onClose: () => void;
  onRepeat: (payment: Payment) => void;
}

const PaymentReceipt = ({ payment, onClose, onRepeat }: PaymentReceiptProps) => {
  if (!payment) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(receiptCopyText(payment));
      toast.success('Receipt copied');
    } catch {
      toast.error('Could not copy the receipt.');
    }
  };

  return (
    <Modal show onHide={onClose} centered scrollable className="nova-receipt-modal">
      <Modal.Header closeButton>
        <Modal.Title>Payment receipt</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="nova-receipt-status">
          <PaymentStatusChip status={payment.status} />
          {payment.status === 'PENDING' && (
            <p className="nova-receipt-note">Processing – we&apos;ll notify you</p>
          )}
          {payment.status === 'FAILED' && (
            <p className="nova-receipt-note nova-receipt-note-bad">Money not debited</p>
          )}
        </div>
        <dl className="nova-receipt-rows">
          {receiptRows(payment).map((row) => (
            <div className="nova-receipt-row" key={row.label}>
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      </Modal.Body>
      <Modal.Footer className="nova-receipt-footer">
        <Button variant="outline" onClick={() => void copy()}>
          Copy details
        </Button>
        <Button onClick={() => onRepeat(payment)}>Repeat</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentReceipt;
